import trackEvent from '@/common/js/track.js'

// 券包中心页面曝光
export function couponPackageCenterSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_center_sw',
    eventLabel: '券包中心页面曝光',
    attrs,
    callback
  })
}

// 券包中心页面购买记录点击
export function couponPackageHistoryCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_history_ck',
    eventLabel: '券包中心页面购买记录点击',
    attrs,
    callback
  })
}

// 券包中心页面可用券实曝光
export function couponPackageAvailableRealexposureSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_available_realexposure_sw',
    eventLabel: '券包中心页面可用券实曝光',
    attrs,
    callback
  })
}

// 券包中心页面可用点击
export function couponPackageAvailableCouponCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_available_coupon_ck',
    eventLabel: '券包中心页面可用点击',
    attrs,
    callback
  })
}

// 券包中心页面可用券more曝光
export function couponPackageAvailableMoreSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_available_more_sw',
    eventLabel: '券包中心页面可用券more曝光',
    attrs,
    callback
  })
}

// 券包中心页面可用券more点击
export function couponPackageAvailableMoreCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_available_more_ck',
    eventLabel: '券包中心页面可用券more点击',
    attrs,
    callback
  })
}

// 券包中心页面券包市场券实曝光
export function couponPackageMarketRealexposureSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_market_realexposure_sw',
    eventLabel: '券包中心页面券包市场券实曝光',
    attrs,
    callback
  })
}

// 券包中心页面券包市场券点击
export function couponPackageMarketCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_market_ck',
    eventLabel: '券包中心券包市场券实点击',
    attrs,
    callback
  })
}

// CGC卡片实曝光
export function landingCgcCardSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_card_sw',
    eventLabel: 'CGC卡片实曝光',
    attrs,
    callback
  })
}

// CGC卡片点击
export function landingCgcCardCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_card_ck',
    eventLabel: 'CGC卡片点击',
    attrs,
    callback
  })
}

// 券包中心页面coupons点击
export function couponPackageCouponsCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_coupons_ck',
    eventLabel: '券包中心页面coupons点击',
    attrs,
    callback
  })
}
